import React, { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import * as _ from 'lodash';
import { verifyTopUpOrder } from 'api/customer';
import { FETCH_PROFILE } from 'actions/profile';
import { GET_DASHBOARD_DATA } from 'actions/dashboard';
import { TOP_UP_INVOICE_STORAGE_KEY, TOP_UP_DONE_MESSAGE } from 'components/common/constant';

// Juspay returns the browser here, either inside the Add Money modal or as a full page
// when netbanking and 3DS navigate the top window
const WalletPaymentStatus = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const verified = useRef(false);

  useEffect(() => {
    if (verified.current) {
      return;
    }
    verified.current = true;

    const framed = window.parent !== window;
    const invoiceId = sessionStorage.getItem(TOP_UP_INVOICE_STORAGE_KEY);
    sessionStorage.removeItem(TOP_UP_INVOICE_STORAGE_KEY);

    const finish = (paid) => {
      // Inside the modal the parent owns the toast and closing
      if (framed) {
        window.parent.postMessage({ type: TOP_UP_DONE_MESSAGE, paid }, window.location.origin);
        return;
      }
      paid ? toast.success('Money added successfully') : toast.info('Your payment is being processed');
      dispatch({ type: FETCH_PROFILE.REQUEST });
      dispatch({ type: GET_DASHBOARD_DATA.REQUEST });
      navigate('/dashboard', { replace: true });
    };

    if (!invoiceId) {
      finish(false);
      return;
    }
    verifyTopUpOrder(invoiceId, {})
      .then((res) => finish(_.get(res, 'data.paid', false)))
      .catch(() => finish(false));
  }, [dispatch, navigate]);

  return <div className="page-loader">Verifying your payment...</div>;
};

export default WalletPaymentStatus;
